import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=51fe8707&scoped=true&"
var script = {}
import style0 from "./Example.vue?vue&type=style&index=0&id=51fe8707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe8707",
  null
  
)

export default component.exports